import { render, staticRenderFns } from "./Analysis.vue?vue&type=template&id=ecb627aa&scoped=true&"
import script from "./Analysis.vue?vue&type=script&lang=js&"
export * from "./Analysis.vue?vue&type=script&lang=js&"
import style0 from "./Analysis.vue?vue&type=style&index=0&id=ecb627aa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecb627aa",
  null
  
)

export default component.exports